// extracted by mini-css-extract-plugin
export default {"effectModal":"OyS0GL","whiteMask":"LG764K"};